export default {
  methods: {
    $textConstruction(payload = {}) {
      const {
        type = 'text',
        name = '',
        wrapperClass = 'py-1 px-5',
        titleText = '',
        titleClass = 'py-1',
        valueText = '',
        valueClass = 'py-1'
      } = payload

      return {
        type,
        name,
        wrapperClass,
        titleText,
        titleClass,
        valueText,
        valueClass
      }
    },

    $textFieldConstruction(payload = {}) {
      const {
        type = 'text-field',
        name = '',
        placeholder = null,
        required = false,
        hint = null,
        persistentHint = false,
        wrapperClass = 'py-2 px-5',
        titleText = '',
        valueText = ''
      } = payload

      return {
        type,
        name,
        placeholder,
        required,
        hint,
        persistentHint,
        wrapperClass,
        titleText,
        valueText
      }
    },

    $dateRangeConstruction(payload = {}) {
      const {
        type = 'date-range',
        name = '',
        canLeaveOneDay = true,
        leaveOneDay = false,
        beginMenu = false,
        beginDate = this.$dateFormat(new Date()),
        finishMenu = false,
        finishDate = this.$dateFormat(new Date(), {
          addUnit: 'd',
          addValue: 1
        }),
        onlyAllday = false,
        beginStatus = 'ALL',
        finishStatus = 'ALL',
        isEverydayWorkingday = false,
        checkSaturday = false,
        checkSunday = false,
        checkHoliday = false,
        wrapperClass = 'py-2 px-5'
      } = payload

      return {
        type,
        name,
        canLeaveOneDay,
        leaveOneDay,
        beginMenu,
        beginDate,
        finishMenu,
        finishDate,
        onlyAllday,
        beginStatus,
        finishStatus,
        isEverydayWorkingday,
        checkSaturday,
        checkSunday,
        checkHoliday,
        wrapperClass
      }
    },

    $fileConstruction(payload = {}) {
      const {
        type = 'file-upload',
        name = '',
        titleText = '',
        placeholder = null,
        required = false,
        hint = '',
        wrapperClass = '',
        file = {}
      } = payload

      return {
        type,
        name,
        placeholder,
        required,
        hint,
        wrapperClass,
        titleText,
        file
      }
    },

    $empSelectConstruction(payload = {}) {
      const {
        type = 'emp-search',
        name = '',
        titleText = '',
        placeholder = null,
        required = false,
        valueText = '',
        empNameTha = '',
        empNameEng = '',
        wrapperClass = ''
      } = payload

      return {
        type,
        name,
        placeholder,
        required,
        valueText,
        empNameTha,
        empNameEng,
        wrapperClass,
        titleText
      }
    },

    $buttonConstruction(payload = {}) {
      const {
        type = 'button',
        name = '',
        buttonType = 'button',
        cols = 'auto',
        label = '',
        small = false,
        large = false,
        disabled = false,
        color = ''
      } = payload

      return {
        type,
        name,
        buttonType,
        cols,
        label,
        small,
        large,
        disabled,
        color
      }
    },

    $buttonSetConstruction(payload = {}) {
      const {
        type = 'button-set',
        name = '',
        buttons = [],
        wrapperClass = ''
      } = payload

      return {
        type,
        name,
        buttons,
        wrapperClass
      }
    }
  }
}
